import { bulkSendMetrics } from 'api/metrics'
import { log } from 'utils'
import EventBuffer from 'utils/eventBuffer'

const BUFFER_TIME_IN_MS = 5000

class MetricEventBuffer extends EventBuffer {
  constructor() {
    super(BUFFER_TIME_IN_MS)
  }

  _publishBuffer = () => {
    if (!this._events.length) {
      return
    }

    bulkSendMetrics(this._events)
      .catch(err => {
        log({type: "warn", data: ['Bulk Metrics Failure']})
      })

    this._resetBuffer()
  }
}

export default new MetricEventBuffer()
